var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_7787567_wrong_delete_remove_trash_minus_icon",
    "data-name": "7787567_wrong_delete_remove_trash_minus_icon",
    d: "M38.95,38.1l2.974-2.974a.6.6,0,1,0-.85-.85L38.1,37.25l-2.974-2.974a.6.6,0,1,0-.85.85L37.25,38.1l-2.974,2.974a.6.6,0,1,0,.85.85L38.1,38.95l2.974,2.974a.6.6,0,1,0,.85-.85Z",
    transform: "translate(-34.1 -34.1)",
    fill: "#484c4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close_grey.7ffb1967885e8932048e2ff04c450d2c.svg";
export { ForwardRef as ReactComponent };